export const colors = {
    coral: '#D7351F',// '#F65954',
    coralDark: 'rgb(126, 21, 7)', // '#922a27',
    inviteAtoll: '#035E64',
    inviteChili: '#D7351F',
    paleYellow: '#FFE5B6', // '#FFEEC7',
    gold: '#FFCB67',
    indigo: '#035E64', // '#154662',
    indigoDark: 'rgb(0, 48, 51)', // '#052b44', // '#09324c',
    tan: '#ECD5BD',
    tanDark: '#866c5a',
    tanDarkest: '#2e231b',
    teal: '#62EEE1',
}